import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';
import AuthMFA from './AuthMFA';

const MFAWrapper = ({ children }) => {
  const [readyToShow, setReadyToShow] = useState(false);
  const [showMFAScreen, setShowMFAScreen] = useState(false);

  const checkAAL = async () => {
    try {
      const { data, error } = await supabase.auth.mfa.getAuthenticatorAssuranceLevel();
      if (error) throw error;
      if (data.nextLevel === 'aal2' && data.nextLevel !== data.currentLevel) {
        setShowMFAScreen(true);
      } else {
        setShowMFAScreen(false);
      }
    } finally {
      setReadyToShow(true);
    }
  };

  useEffect(() => {
    // Si es un flujo de recovery, no bloqueamos con MFA
    const hashParams = new URLSearchParams(window.location.hash.substring(1));
    const type = hashParams.get('type');
    const isResetPage = window.location.pathname === '/reset-password';
    if (type === 'recovery' || type === 'invite' || isResetPage) {
      setReadyToShow(true);
      return;
    }

    checkAAL();
    const { data: { subscription } } = supabase.auth.onAuthStateChange(() => {
      checkAAL();
    });
    return () => subscription.unsubscribe();
  }, []);

  if (!readyToShow) return null;
  if (showMFAScreen) return <AuthMFA />;
  return children;
};

export default MFAWrapper;
